module.exports = __webpack_public_path__ + "img/message_dong.0155a12c.png";